module.exports = __webpack_public_path__ + "img/C04Horseman3_ua.2fa44ebc.webp";